// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/arrows/arrowdownblack.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services .heading_first {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 600;
  line-height: 32.78px;
  text-align: left;
  color: #000;

  .heading_second {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 700;
    line-height: 32.78px;
    text-align: left;
    color: #1b9075;
  }
}

.services .services_topbar {
  width: auto;
  height: 69px;
  gap: 0px;
  border-radius: 5px;
  background: #ffffff;
  border: 1px solid #e7e7e7;
}

.services .services_topbar .head_link {
  font-family: Manrope;
  font-size: 15px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  color: #000000;
}

.services .services_topbar .activeHead {
  display: flex;
  align-items: center;
  width: auto;
  /* width: 179px; */
  height: 41px;
  border-radius: 21px;
  border: 1px solid #e9f4f1;
  background: #1b9075;
  color: #fff;
  box-shadow: 0px 2px 24px 0px #0000002e;

  span {
    padding: 1rem;
  }
}


.service_card {
  /* width: 360px; */
  /* height: 520px; */
  width: auto;
  height: auto;
  border-radius: 4px;
  background: #FFFFFF;

}

.service_card .service_body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
}

.serviceImageWrap>img {
  width: 100%;
}

.service_card .service_price {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  width: 160px;
  height: 51px;
  border-radius: 25.5px;
  background: #FFFFFF;
  box-shadow: 0px 2px 22px 0px #00000021;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-family: Manrope;
    font-size: 20px;
    font-weight: 700;
    line-height: 32px;
    color: #1B9075;

  }
}

.service_card .service_head {
  /* width: 95px; */
  /* height: 32px; */
  width: auto;
  height: auto;
  margin-top: 25px;
  font-family: Manrope;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

}

.service_card .service_description {
  width: calc(100% - 100px);
  overflow: hidden;
  /* height: 26px; */
  /* width: auto; */
  height: auto;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 500;
  line-height: 25.6px;
  text-align: left;
  color: #949298;

}

.service_card .services_desc_view {
  /* width: 80px; */
  /* height: 26px; */
  width: 95px;
  height: auto;

  font-family: Manrope;
  font-size: 16px;
  font-weight: 700;
  line-height: 25.6px;
  text-align: center;
  color: #1B9075;

}

.services_card .service_card .service_button {
  width: 100%;
  height: 56px;
  padding: 20px;
  border-radius: 10px;
  background: #1b9075;
  font-family: Manrope;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #fff;
}


/* css for booking services page*/

.book_service .breadcrump nav ol li {
  .first_link {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    text-align: left;
    color: #000000;
  }

  .second_link {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    text-align: left;
    color: #1B9075;
  }
}

.book_service .service_heading {
  width: 278px;
  /* height: 54px; */
  /* width: auto; */
  height: auto;
  padding: 1rem;
  border-radius: 31px;
  border: 1px solid #1B9075;
  background: #F7FFFD;


  .first_head {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 25.6px;
    text-align: left;
    color: #1B9075;
  }

  .second_head {
    font-family: Manrope;
    font-size: 16px;
    font-weight: 600;
    line-height: 25.6px;
    text-align: left;

  }
}

.book_service .add_booking {
  .first_head {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 600;
    line-height: 32.78px;
    text-align: left;
    /* color: #1B9075; */
  }

  .second_head {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 600;
    line-height: 32.78px;
    text-align: left;
  }
}

.book_service .add_booking .add_booking_fields {
  .input_field {
    /* width: 350px;*/
    height: 58px;
    border-radius: 5px;
    /* border: 1px solid #1B9075; */
  }

  .select_quantity {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right;
  }
}



.book_service .pick_location {
  .first_head {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 600;
    line-height: 32.78px;
    text-align: left;
  }

  .second_head {
    font-family: Manrope;
    font-size: 24px;
    font-weight: 600;
    line-height: 32.78px;
    text-align: left;
    color: #1B9075;
  }
}

.book_service .pick_location .pick_location_body .pick_location_fields {
  .input_field {
    /* width: 350px;*/
    height: 58px;
    border-radius: 5px;
    /* border: 1px solid #1B9075; */
  }
}


.book_service .service_buttons {
  .cancel {
    width: 147.57px;
    height: 42px;
    border-radius: 9px;
    background: #E4EFEC;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    color: #1B9075;
  }

  .next {
    width: 147.57px;
    height: 42px;
    border-radius: 9px;
    background-color: #1B9075;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    color: #fff;
  }
}

.book_service .booking_offcanvas {
  .head {
    /* width: 555px; */
    width: auto;
    height: 80px;
    background: #1B9075;

    .heading {
      width: 220px;
      height: 22px;

      font-family: Manrope;
      font-size: 22px;
      font-weight: 700;
      line-height: 22px;
      text-align: left;
      color: #fff;
    }
  }

  .body {
    /* width: 511px; */
    width: auto;
    height: 118px;
    border-radius: 6px;

    .payment_method {
      .first_head {
        font-family: Manrope;
        font-size: 18px;
        font-weight: 500;
        line-height: 16px;
        text-align: left;
        color: #000000;

      }

      .second_head {
        font-family: Manrope;
        font-size: 18px;
        font-weight: 600;
        line-height: 16px;
        text-align: left;
        color: #1B9075;
      }
    }

    .foo_ter {
      background: #F4F4F4;
      /* width: 555px; */
      width: auto;
      height: 100px;

      .button {
        width: 147.57px;
        height: 42px;
        border-radius: 9px;
        background-color: #1B9075;
        font-family: Poppins;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
        text-align: center;
        color: #fff;
      }
    }

    .service_coupon {
      /* width: 511px; */
      width: auto;
      height: 102px;
      border-radius: 6px;
      box-shadow: 0px 2px 22px 0px #0000001A;
      background: #FFFFFF;
    }
  }
}

.service_coupon_button {
  width: 103px;
  height: 54px;
  border-radius: 10px;
  background: #1B9075;
  font-family: Manrope;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #fff;
}

.foo_ter {
  background: #F4F4F4;
  /* width: 555px; */
  width: auto;
  height: 100px;

  .button {
    /* width: 147.57px; */
    width: 100%;
    height: 42px;
    border-radius: 9px;
    background-color: #1B9075;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    color: #fff;
  }
}

/* style for booking confirmation details offcanvas */

.book_service .confirm_booking_offcanvas {
  .head {
    /* width: 555px; */
    width: auto;
    height: 80px;
    background: #1B9075;

    .confirm_booking_heading {
      width: 342px;
      height: 22px;

      font-family: Manrope;
      font-size: 22px;
      font-weight: 700;
      line-height: 22px;
      text-align: left;
      color: #fff;
    }
  }

  .body {
    /* width: 511px; */
    width: auto;
    height: 118px;
    border-radius: 6px;

    .booking_details_head {
      font-family: Manrope;
      font-size: 20px;
      font-weight: 700;
      line-height: 22px;
      text-align: left;
      color: #1B9075;
    }

    .selected_services,
    .services_details,
    .working_time_details,
    .location_details,
    .note_details,
    .cost_details,
    .service_agent_name,
    .service_payment_method {
      /* width: 125px; */
      width: auto;
      height: 22px;
      font-family: Manrope;
      font-size: 16px;
      font-weight: 400;
      line-height: 22px;
      text-align: left;
    }

    .text {
      font-family: Manrope;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
      text-align: left;
      color: #000000;

    }

    .round_dot {
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #1B9075;
      border-radius: 50%;
      margin: 0 1rem;
    }

    .view_button_more_less {
      font-family: Manrope;
      font-size: 16px;
      font-weight: 700;
      line-height: 25.6px;
      text-align: center;
      color: #1B9075;
    }
  }
}



/* style for modal */

.booking_confirm {
  /* width: 477px; */
  /* height: 571px; */
  width: auto;
  height: auto;
  border-radius: 8px;

}

.booking_confirm .body {
  .booking_confirm_heading {
    font-family: Manrope;
    font-size: 22px;
    font-weight: 800;
    line-height: 32px;
    text-align: center;
    color: #1B9075;
  }

  .first_text {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: #000000;

  }

  .second_text {
    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
    color: #000000;
  }

}

.booking_confirm .body .modal_button_section {
  .modal_view_button {
    width: 205px;
    height: 56px;
    /* width: auto; */
    /* height: auto; */
    border-radius: 9px;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 24px;
    text-align: center;
    background: #E4EFEC;
    color: #1B9075;

  }

  .modal_home_button {
    width: 205px;
    height: 56px;
    /* width: auto; */
    /* height: auto; */
    border-radius: 10px;
    background: #1B9075;
    font-family: Manrope;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.02em;
    text-align: center;

    color: #fff;
  }
}

/* for list modal */
.list_services {
  /* width: 233px; */
  /* height: 68px; */
  height: auto;
  top: 1438px;
  left: 222px;
  gap: 10px;
  opacity: 0px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow-y: auto;

  ol {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  ol li {
    display: flex;
    align-items: center;
    /* width: 88px; */
    height: 18px;
    /* top: 1488px;
              left: 222px; */
    gap: 10px;
    opacity: 0px;

    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: #000;
  }

  ul li {
    display: flex;
    align-items: center;
    /* width: 88px; */
    height: 18px;
    /* top: 1488px;
              left: 222px; */
    gap: 10px;
    opacity: 0px;

    font-family: Manrope;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    color: #000;
  }

  ol li {
    position: relative;
    padding-left: 20px;
  }

  ol li::before {
    content: '';
    position: absolute;
    left: -10px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #1b9075;
    opacity: 0;
    transform: translateY(-50%);
  }

  ul li {
    position: relative;
    padding-left: 20px;
  }

  ul li::before {
    content: '';
    position: absolute;
    left: -10px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #1b9075;
    opacity: 0;
    transform: translateY(-50%);
  }
}

.services .service_body .modal_dialog .modal_content .modal_header {
  width: auto;
  height: 48px;
  background: #1B9075;

  .head {
    color: #fff;
  }

  .close_button {
    color: #ffffff;
    border-radius: 50%;
  }
}

/* media queries for the offcanvas */

@media (max-width: 499px) {
  .booking_offcanvas {
    width: 100%;
  }

  .confirm_booking_offcanvas {
    width: 100%;
  }
}

@media (min-width: 500px) and (max-width: 640px) {
  .booking_offcanvas {
    width: 100%;
  }

  .confirm_booking_offcanvas {
    width: 100%;
  }
}

@media (min-width: 641px) and (max-width: 1024px) {
  .booking_offcanvas {
    width: 75%;
  }

  .confirm_booking_offcanvas {
    width: 75%;
  }
}

@media (min-width: 1025px) and (max-width: 1368px) {
  .booking_offcanvas {
    width: 50%;
  }

  .confirm_booking_offcanvas {
    width: 50%;
  }
}

@media (max-width: 768px) {
  .services .services_topbar {
    flex-flow: column;
    align-items: start;
    gap: 15px;
    height: auto;
    padding: 15px;
  }

  .services .services_topbar span {
    padding: 1rem;
  }

  .booking .booking_topbar .head_link {
    padding: .5rem .5rem;
  }

  .service_card .service_head,
  .service_card .service_price span {
    font-size: 16px;
  }

  .service_card .service_price {
    bottom: -20px;
    width: 120px;
    height: 45px;
  }

  .booking .booking_topbar {
    height: auto !important;
    gap: 5px !important;
  }

}

@media (max-width: 575px) {
  .detailBox {
    flex-flow: column;
  }

  .detailBox .details_button {
    padding-left: 20px;
  }

}

@media (max-width: 360px) {
  .booking_topbar {
    flex-flow: column;
    align-items: start;
    gap: 15px;
    height: auto;
    padding: 15px;
  }

  .head_details {
    flex-flow: column;
    align-items: flex-start;
    gap: 15px;
  }

  .otp_section {
    padding-left: 10px;
  }

  .detailBox .first_section {
    flex-flow: column;
    align-items: flex-start;
  }

  .detailBox .details_button {
    padding-left: 0px;
    margin-bottom: 15px;
  }

  .agent_status_text {
    font-size: 13px !important;
    padding: 0 !important;
  }

}`, "",{"version":3,"sources":["webpack://./src/styles/postlogin/services.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;;EAEX;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,sCAAsC;;EAEtC;IACE,aAAa;EACf;AACF;;;AAGA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;;EAEhB;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;;AAElB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;;AAEhB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;;AAGA,iCAAiC;;AAEjC;EACE;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;;;EAGnB;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;;EAElB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,yEAA+E;EACjF;AACF;;;;AAIA;EACE;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;EACjC;AACF;;;AAGA;EACE;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;MACE,YAAY;MACZ,YAAY;;MAEZ,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,WAAW;IACb;EACF;;EAKA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;;IAElB;MACE;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;;MAEhB;;MAEA;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;MAChB;IACF;;IAEA;MACE,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,aAAa;;MAEb;QACE,eAAe;QACf,YAAY;QACZ,kBAAkB;QAClB,yBAAyB;QACzB,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;MACb;IACF;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,sCAAsC;MACtC,mBAAmB;IACrB;EACF;AA3DF;;AA8DA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;;EAEb;IACE,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;AACF;;AAEA,qDAAqD;;AAErD;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB;MACE,YAAY;MACZ,YAAY;;MAEZ,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,WAAW;IACb;EACF;;EAKA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;;IAElB;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;;;;;;;;MAQE,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;MAChB,cAAc;;IAEhB;;IAEA;MACE,qBAAqB;MACrB,UAAU;MACV,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,eAAe;MACf,gBAAgB;MAChB,mBAAmB;MACnB,kBAAkB;MAClB,cAAc;IAChB;EACF;AAhEF;;;;AAqEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;EAEhB;;EAEA;IACE,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;;EAEhB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;;IAElB,WAAW;EACb;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;;EAEhB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ;4BACwB;IACxB,SAAS;IACT,YAAY;;IAEZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ;4BACwB;IACxB,SAAS;IACT,YAAY;;IAEZ,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;;EAEnB;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,qBAAqB;EACvB;;AAEF","sourcesContent":[".services .heading_first {\n  font-family: Manrope;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 32.78px;\n  text-align: left;\n  color: #000;\n\n  .heading_second {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 700;\n    line-height: 32.78px;\n    text-align: left;\n    color: #1b9075;\n  }\n}\n\n.services .services_topbar {\n  width: auto;\n  height: 69px;\n  gap: 0px;\n  border-radius: 5px;\n  background: #ffffff;\n  border: 1px solid #e7e7e7;\n}\n\n.services .services_topbar .head_link {\n  font-family: Manrope;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 24px;\n  text-align: left;\n  color: #000000;\n}\n\n.services .services_topbar .activeHead {\n  display: flex;\n  align-items: center;\n  width: auto;\n  /* width: 179px; */\n  height: 41px;\n  border-radius: 21px;\n  border: 1px solid #e9f4f1;\n  background: #1b9075;\n  color: #fff;\n  box-shadow: 0px 2px 24px 0px #0000002e;\n\n  span {\n    padding: 1rem;\n  }\n}\n\n\n.service_card {\n  /* width: 360px; */\n  /* height: 520px; */\n  width: auto;\n  height: auto;\n  border-radius: 4px;\n  background: #FFFFFF;\n\n}\n\n.service_card .service_body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  position: relative;\n}\n\n.serviceImageWrap>img {\n  width: 100%;\n}\n\n.service_card .service_price {\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 160px;\n  height: 51px;\n  border-radius: 25.5px;\n  background: #FFFFFF;\n  box-shadow: 0px 2px 22px 0px #00000021;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  span {\n    font-family: Manrope;\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 32px;\n    color: #1B9075;\n\n  }\n}\n\n.service_card .service_head {\n  /* width: 95px; */\n  /* height: 32px; */\n  width: auto;\n  height: auto;\n  margin-top: 25px;\n  font-family: Manrope;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 32px;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n}\n\n.service_card .service_description {\n  width: calc(100% - 100px);\n  overflow: hidden;\n  /* height: 26px; */\n  /* width: auto; */\n  height: auto;\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 25.6px;\n  text-align: left;\n  color: #949298;\n\n}\n\n.service_card .services_desc_view {\n  /* width: 80px; */\n  /* height: 26px; */\n  width: 95px;\n  height: auto;\n\n  font-family: Manrope;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 25.6px;\n  text-align: center;\n  color: #1B9075;\n\n}\n\n.services_card .service_card .service_button {\n  width: 100%;\n  height: 56px;\n  padding: 20px;\n  border-radius: 10px;\n  background: #1b9075;\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: #fff;\n}\n\n\n/* css for booking services page*/\n\n.book_service .breadcrump nav ol li {\n  .first_link {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 16px;\n    text-align: left;\n    color: #000000;\n  }\n\n  .second_link {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 16px;\n    text-align: left;\n    color: #1B9075;\n  }\n}\n\n.book_service .service_heading {\n  width: 278px;\n  /* height: 54px; */\n  /* width: auto; */\n  height: auto;\n  padding: 1rem;\n  border-radius: 31px;\n  border: 1px solid #1B9075;\n  background: #F7FFFD;\n\n\n  .first_head {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 25.6px;\n    text-align: left;\n    color: #1B9075;\n  }\n\n  .second_head {\n    font-family: Manrope;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 25.6px;\n    text-align: left;\n\n  }\n}\n\n.book_service .add_booking {\n  .first_head {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32.78px;\n    text-align: left;\n    /* color: #1B9075; */\n  }\n\n  .second_head {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32.78px;\n    text-align: left;\n  }\n}\n\n.book_service .add_booking .add_booking_fields {\n  .input_field {\n    /* width: 350px;*/\n    height: 58px;\n    border-radius: 5px;\n    /* border: 1px solid #1B9075; */\n  }\n\n  .select_quantity {\n    background-image: url(\"../../assets/arrows/arrowdownblack.svg\") no-repeat right;\n  }\n}\n\n\n\n.book_service .pick_location {\n  .first_head {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32.78px;\n    text-align: left;\n  }\n\n  .second_head {\n    font-family: Manrope;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32.78px;\n    text-align: left;\n    color: #1B9075;\n  }\n}\n\n.book_service .pick_location .pick_location_body .pick_location_fields {\n  .input_field {\n    /* width: 350px;*/\n    height: 58px;\n    border-radius: 5px;\n    /* border: 1px solid #1B9075; */\n  }\n}\n\n\n.book_service .service_buttons {\n  .cancel {\n    width: 147.57px;\n    height: 42px;\n    border-radius: 9px;\n    background: #E4EFEC;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n    color: #1B9075;\n  }\n\n  .next {\n    width: 147.57px;\n    height: 42px;\n    border-radius: 9px;\n    background-color: #1B9075;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n    color: #fff;\n  }\n}\n\n.book_service .booking_offcanvas {\n  .head {\n    /* width: 555px; */\n    width: auto;\n    height: 80px;\n    background: #1B9075;\n\n    .heading {\n      width: 220px;\n      height: 22px;\n\n      font-family: Manrope;\n      font-size: 22px;\n      font-weight: 700;\n      line-height: 22px;\n      text-align: left;\n      color: #fff;\n    }\n  }\n}\n\n.book_service .booking_offcanvas {\n\n  .body {\n    /* width: 511px; */\n    width: auto;\n    height: 118px;\n    border-radius: 6px;\n\n    .payment_method {\n      .first_head {\n        font-family: Manrope;\n        font-size: 18px;\n        font-weight: 500;\n        line-height: 16px;\n        text-align: left;\n        color: #000000;\n\n      }\n\n      .second_head {\n        font-family: Manrope;\n        font-size: 18px;\n        font-weight: 600;\n        line-height: 16px;\n        text-align: left;\n        color: #1B9075;\n      }\n    }\n\n    .foo_ter {\n      background: #F4F4F4;\n      /* width: 555px; */\n      width: auto;\n      height: 100px;\n\n      .button {\n        width: 147.57px;\n        height: 42px;\n        border-radius: 9px;\n        background-color: #1B9075;\n        font-family: Poppins;\n        font-size: 14px;\n        font-weight: 600;\n        line-height: 24px;\n        text-align: center;\n        color: #fff;\n      }\n    }\n\n    .service_coupon {\n      /* width: 511px; */\n      width: auto;\n      height: 102px;\n      border-radius: 6px;\n      box-shadow: 0px 2px 22px 0px #0000001A;\n      background: #FFFFFF;\n    }\n  }\n}\n\n.service_coupon_button {\n  width: 103px;\n  height: 54px;\n  border-radius: 10px;\n  background: #1B9075;\n  font-family: Manrope;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 20px;\n  letter-spacing: 0.02em;\n  text-align: center;\n  color: #fff;\n}\n\n.foo_ter {\n  background: #F4F4F4;\n  /* width: 555px; */\n  width: auto;\n  height: 100px;\n\n  .button {\n    /* width: 147.57px; */\n    width: 100%;\n    height: 42px;\n    border-radius: 9px;\n    background-color: #1B9075;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n    color: #fff;\n  }\n}\n\n/* style for booking confirmation details offcanvas */\n\n.book_service .confirm_booking_offcanvas {\n  .head {\n    /* width: 555px; */\n    width: auto;\n    height: 80px;\n    background: #1B9075;\n\n    .confirm_booking_heading {\n      width: 342px;\n      height: 22px;\n\n      font-family: Manrope;\n      font-size: 22px;\n      font-weight: 700;\n      line-height: 22px;\n      text-align: left;\n      color: #fff;\n    }\n  }\n}\n\n.book_service .confirm_booking_offcanvas {\n\n  .body {\n    /* width: 511px; */\n    width: auto;\n    height: 118px;\n    border-radius: 6px;\n\n    .booking_details_head {\n      font-family: Manrope;\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 22px;\n      text-align: left;\n      color: #1B9075;\n    }\n\n    .selected_services,\n    .services_details,\n    .working_time_details,\n    .location_details,\n    .note_details,\n    .cost_details,\n    .service_agent_name,\n    .service_payment_method {\n      /* width: 125px; */\n      width: auto;\n      height: 22px;\n      font-family: Manrope;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 22px;\n      text-align: left;\n    }\n\n    .text {\n      font-family: Manrope;\n      font-size: 16px;\n      font-weight: 600;\n      line-height: 22px;\n      text-align: left;\n      color: #000000;\n\n    }\n\n    .round_dot {\n      display: inline-block;\n      width: 5px;\n      height: 5px;\n      background: #1B9075;\n      border-radius: 50%;\n      margin: 0 1rem;\n    }\n\n    .view_button_more_less {\n      font-family: Manrope;\n      font-size: 16px;\n      font-weight: 700;\n      line-height: 25.6px;\n      text-align: center;\n      color: #1B9075;\n    }\n  }\n}\n\n\n\n/* style for modal */\n\n.booking_confirm {\n  /* width: 477px; */\n  /* height: 571px; */\n  width: auto;\n  height: auto;\n  border-radius: 8px;\n\n}\n\n.booking_confirm .body {\n  .booking_confirm_heading {\n    font-family: Manrope;\n    font-size: 22px;\n    font-weight: 800;\n    line-height: 32px;\n    text-align: center;\n    color: #1B9075;\n  }\n\n  .first_text {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: center;\n    color: #000000;\n\n  }\n\n  .second_text {\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 24px;\n    text-align: center;\n    color: #000000;\n  }\n\n}\n\n.booking_confirm .body .modal_button_section {\n  .modal_view_button {\n    width: 205px;\n    height: 56px;\n    /* width: auto; */\n    /* height: auto; */\n    border-radius: 9px;\n    font-family: Poppins;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: center;\n    background: #E4EFEC;\n    color: #1B9075;\n\n  }\n\n  .modal_home_button {\n    width: 205px;\n    height: 56px;\n    /* width: auto; */\n    /* height: auto; */\n    border-radius: 10px;\n    background: #1B9075;\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    letter-spacing: 0.02em;\n    text-align: center;\n\n    color: #fff;\n  }\n}\n\n/* for list modal */\n.list_services {\n  /* width: 233px; */\n  /* height: 68px; */\n  height: auto;\n  top: 1438px;\n  left: 222px;\n  gap: 10px;\n  opacity: 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  overflow-y: auto;\n\n  ol {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  ol li {\n    display: flex;\n    align-items: center;\n    /* width: 88px; */\n    height: 18px;\n    /* top: 1488px;\n              left: 222px; */\n    gap: 10px;\n    opacity: 0px;\n\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    text-align: left;\n    color: #000;\n  }\n\n  ul li {\n    display: flex;\n    align-items: center;\n    /* width: 88px; */\n    height: 18px;\n    /* top: 1488px;\n              left: 222px; */\n    gap: 10px;\n    opacity: 0px;\n\n    font-family: Manrope;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    text-align: left;\n    color: #000;\n  }\n\n  ol li {\n    position: relative;\n    padding-left: 20px;\n  }\n\n  ol li::before {\n    content: '';\n    position: absolute;\n    left: -10px;\n    top: 50%;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background-color: #1b9075;\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n\n  ul li {\n    position: relative;\n    padding-left: 20px;\n  }\n\n  ul li::before {\n    content: '';\n    position: absolute;\n    left: -10px;\n    top: 50%;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background-color: #1b9075;\n    opacity: 0;\n    transform: translateY(-50%);\n  }\n}\n\n.services .service_body .modal_dialog .modal_content .modal_header {\n  width: auto;\n  height: 48px;\n  background: #1B9075;\n\n  .head {\n    color: #fff;\n  }\n\n  .close_button {\n    color: #ffffff;\n    border-radius: 50%;\n  }\n}\n\n/* media queries for the offcanvas */\n\n@media (max-width: 499px) {\n  .booking_offcanvas {\n    width: 100%;\n  }\n\n  .confirm_booking_offcanvas {\n    width: 100%;\n  }\n}\n\n@media (min-width: 500px) and (max-width: 640px) {\n  .booking_offcanvas {\n    width: 100%;\n  }\n\n  .confirm_booking_offcanvas {\n    width: 100%;\n  }\n}\n\n@media (min-width: 641px) and (max-width: 1024px) {\n  .booking_offcanvas {\n    width: 75%;\n  }\n\n  .confirm_booking_offcanvas {\n    width: 75%;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1368px) {\n  .booking_offcanvas {\n    width: 50%;\n  }\n\n  .confirm_booking_offcanvas {\n    width: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .services .services_topbar {\n    flex-flow: column;\n    align-items: start;\n    gap: 15px;\n    height: auto;\n    padding: 15px;\n  }\n\n  .services .services_topbar span {\n    padding: 1rem;\n  }\n\n  .booking .booking_topbar .head_link {\n    padding: .5rem .5rem;\n  }\n\n  .service_card .service_head,\n  .service_card .service_price span {\n    font-size: 16px;\n  }\n\n  .service_card .service_price {\n    bottom: -20px;\n    width: 120px;\n    height: 45px;\n  }\n\n  .booking .booking_topbar {\n    height: auto !important;\n    gap: 5px !important;\n  }\n\n}\n\n@media (max-width: 575px) {\n  .detailBox {\n    flex-flow: column;\n  }\n\n  .detailBox .details_button {\n    padding-left: 20px;\n  }\n\n}\n\n@media (max-width: 360px) {\n  .booking_topbar {\n    flex-flow: column;\n    align-items: start;\n    gap: 15px;\n    height: auto;\n    padding: 15px;\n  }\n\n  .head_details {\n    flex-flow: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n\n  .otp_section {\n    padding-left: 10px;\n  }\n\n  .detailBox .first_section {\n    flex-flow: column;\n    align-items: flex-start;\n  }\n\n  .detailBox .details_button {\n    padding-left: 0px;\n    margin-bottom: 15px;\n  }\n\n  .agent_status_text {\n    font-size: 13px !important;\n    padding: 0 !important;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
